import type { ReactElement } from 'react'

import { theme } from '@procurify/ui-theme'

import { type IIconButtonProps } from './IconButton'
import { type IIconComponentProps, renderIcon } from '../Icon'
import { CircleLoader } from '../Loaders'
import { TransparentIconButtonStyled } from './styles/TransparentIconButtonStyled'
import { getAnalyticsDataAttrs } from '@ui/utils/analytics'

export interface ITransparentIconButtonProps extends IIconButtonProps {
  iconColor?: IIconComponentProps['color']
}

export const TransparentIconButton = ({
  htmlTitle,
  onClick,
  isLoading,
  iconComponent,
  disabled,
  iconColor,
  analyticsId,
  ...otherProps
}: ITransparentIconButtonProps) => {
  const analyticsProps = getAnalyticsDataAttrs(analyticsId)

  return (
    <TransparentIconButtonStyled
      title={htmlTitle}
      onClick={!isLoading ? onClick : undefined}
      isLoading={isLoading}
      disabled={disabled || isLoading}
      {...analyticsProps}
      {...otherProps}
    >
      {!isLoading ? (
        renderIcon(iconComponent as ReactElement, { color: iconColor })
      ) : (
        <CircleLoader
          size={14}
          color={
            iconColor
              ? theme.colors[iconColor]
              : theme.colors.button.transparentIcon.content.default
          }
        />
      )}
    </TransparentIconButtonStyled>
  )
}
